<script>
  import { format } from 'svelte-i18n';

  import { base } from '@client/app/themes/base';

  import { FieldHeader, FieldLabel } from '@client/components/fields/standalone/base';
  import { currentThemeName, themes } from '@client/components/theme';

  export let onThemeUpdate = () => {};

  $: themeItems = Object.keys($themes).map((value) => ({ label: value, value }));
</script>

<div class="theme-field">
  <FieldHeader>
    <FieldLabel label={$format('label.THEME')} />
  </FieldHeader>

  <div class="theme-selection">
    {#each themeItems as theme}
      <div class="theme-option" class:active={$currentThemeName === theme.value}>
        <div
          class="mini-theme"
          on:click={() => onThemeUpdate('theme', 'Theme', { ...theme, label: $themes[theme.value].meta.name })}
          role="button"
          tabindex="0"
        >
          <div
            class="mini-sidebar"
            style="background-color: {$themes[theme.value].sidebar?.background?.color ||
              base.sidebar?.background?.color};"
          >
            <div class="mini-header">
              <div class="mini-logo" />
            </div>
            <div class="mini-list">
              <div class="mini-list-item">
                <div
                  class="mini-list-item-icon"
                  style="background-color: {$themes[theme.value].sidebar?.section?.item?.icon?.background?.color?._ ||
                    'rgba(200,200,200,.25)'};"
                />
                <div
                  class="mini-list-item-text"
                  style="background-color: {$themes[theme.value].sidebar?.section?.item?.color?._ ||
                    base.sidebar?.section?.item?.color?._}; width: 70%;"
                />
              </div>
              <div class="mini-list-item">
                <div
                  class="mini-list-item-icon"
                  style="background-color: {$themes[theme.value].sidebar?.section?.heading?.icon?.background?.color
                    ?.active || base.sidebar?.section?.heading?.icon?.backgroundColor?.active};"
                />
                <div
                  class="mini-list-item-text"
                  style="background-color: {$themes[theme.value].sidebar?.section?.heading?.color?.active ||
                    base.sidebar?.section?.heading?.color?.active}; width: 60%;"
                />
              </div>
              <div class="mini-list-item">
                <div
                  class="mini-list-item-icon"
                  style="background-color: {$themes[theme.value].sidebar?.section?.item?.icon?.background?.color?._ ||
                    'rgba(200,200,200,.25)'};"
                />
                <div
                  class="mini-list-item-text"
                  style="background-color: {$themes[theme.value].sidebar?.section?.heading?.color?._ ||
                    base.sidebar?.section?.heading?.color?._};  width: 55%;"
                />
              </div>
              <div class="mini-list-item">
                <div
                  class="mini-list-item-icon"
                  style="background-color: {$themes[theme.value].sidebar?.section?.item?.icon?.background?.color?._ ||
                    'rgba(200,200,200,.25)'};"
                />
                <div
                  class="mini-list-item-text"
                  style="background-color: {$themes[theme.value].sidebar?.section?.heading?.color?._ ||
                    base.sidebar?.section?.heading?.color?._}; width: 40%;"
                />
              </div>
            </div>
          </div>
          <div class="mini-content">
            <div class="mini-toggle" />
          </div>
        </div>
        <div class="theme-name">
          {$themes[theme.value].meta.name}
        </div>
      </div>
    {/each}
  </div>
</div>

<style lang="scss" src="./themes.scss"></style>
